import { cx } from '@UI/lib/utils';

interface RevHubLogoProps extends React.SVGProps<SVGSVGElement> {
  width?: string;
  height?: string;
  className?: string;
}

const RevHubLogo: React.FC<RevHubLogoProps> = ({
  width,
  height,
  className,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 250 138"
    {...rest}
    className={cx('revHubLogo', className)}
  >
    <path
      className="bg"
      d="M250.4,69c0,37.8-30.7,68.5-68.5,68.5s-68.5-30.7-68.5-68.5s30.7-68.5,68.5-68.5S250.4,31.2,250.4,69z"
    />
    <path
      className="rev"
      d="M85.5,91.6L73.8,59.5h10.1l7.5,23.2l7.5-23.2h10L97.1,91.6H85.5z M69.1,66.6c-1.4-2.4-3.3-4.3-5.7-5.7
		s-5.3-2.1-8.5-2.1c-3.3,0-6.2,0.7-8.7,2.2s-4.5,3.5-5.9,6.1s-2.1,5.6-2.1,8.9c0,3.2,0.7,6.1,2.1,8.6c1.4,2.5,3.4,4.4,5.9,5.8
		s5.4,2,8.7,2c2.5,0,4.8-0.5,6.9-1.4c2.1-1,3.8-2.3,5.3-3.9c1.4-1.7,2.5-3.5,3.1-5.6h-9.8c-0.5,0.9-1.2,1.6-2.2,2.2
		c-0.9,0.6-2,0.8-3.4,0.8c-1.5,0-2.8-0.3-3.9-1c-1.1-0.6-1.9-1.5-2.5-2.7c-0.4-0.9-0.7-1.9-0.8-3.1H71c0.1-0.6,0.1-1.1,0.1-1.6
		c0-0.6,0.1-1,0.1-1.5C71.2,71.7,70.5,68.9,69.1,66.6z M48,72.4c0.2-0.8,0.4-1.5,0.7-2.1c0.7-1.3,1.6-2.2,2.7-2.9
		c1.1-0.6,2.3-1,3.7-1c1.8,0,3.3,0.6,4.5,1.7s1.9,2.5,2,4.3H48z M25.3,73.3c0.6-0.2,1.1-0.5,1.7-0.7c2.4-1.3,4.1-3,5.2-5
		c1.1-2.1,1.7-4.3,1.7-6.7c0-2.6-0.6-4.9-1.8-7c-1.1-2.1-2.9-3.7-5.4-5c-2.4-1.3-5.4-1.9-9-1.9H0.4v44.7H10V74.5h5.6l7.9,17.2h10.8
		L25.3,73.3z M22.4,65.9c-1.1,1.1-2.8,1.7-5.2,1.7H10V54.9h7.2c2.4,0,4.1,0.6,5.2,1.7c1.1,1.1,1.7,2.6,1.7,4.5
		C24.1,63.2,23.6,64.7,22.4,65.9z"
    />
    <path
      className="hub"
      d="M227.6,92.4c-1.6,0-3-0.2-4.3-0.6c-1.2-0.4-2.3-0.9-3.3-1.6c-0.9-0.7-1.7-1.5-2.4-2.4l-1.1,3.8H208V45.7h9.6
		v18c1-1.4,2.3-2.6,4-3.6c1.6-0.9,3.6-1.4,6-1.4c2.9,0,5.6,0.7,7.8,2.2c2.3,1.4,4.2,3.4,5.6,6c1.4,2.5,2,5.4,2,8.7
		c0,3.2-0.7,6.1-2,8.6c-1.4,2.6-3.2,4.6-5.5,6C233.1,91.7,230.5,92.4,227.6,92.4z M225.2,84c1.5,0,2.9-0.4,4.1-1.1
		c1.2-0.7,2.2-1.7,2.9-2.9c0.7-1.3,1-2.7,1-4.4c0-1.7-0.3-3.1-1-4.4s-1.6-2.3-2.9-3.1c-1.2-0.7-2.6-1.1-4.1-1.1
		c-1.6,0-3,0.4-4.2,1.1s-2.1,1.7-2.8,3c-0.7,1.2-1,2.7-1,4.4c0,1.6,0.3,3.1,1,4.3c0.7,1.3,1.6,2.3,2.8,3
		C222.2,83.7,223.6,84,225.2,84z M180,92.4c-2.7,0-5-0.6-6.8-1.7S170,88,169,85.9c-0.9-2.2-1.4-4.8-1.4-7.9V59.5h9.6V77
		c0,2.4,0.5,4.2,1.5,5.5c1,1.2,2.6,1.9,4.7,1.9c1.3,0,2.5-0.3,3.5-0.9c1.1-0.6,1.9-1.5,2.4-2.6c0.6-1.1,0.9-2.6,0.9-4.2V59.5h9.6
		v32.2h-8.4l-0.8-5.1c-0.9,1.7-2.3,3.2-4.1,4.3C184.7,91.9,182.5,92.4,180,92.4z M149.9,47v18h-18.4V47h-9.6v44.7h9.6v-19h18.4v18.9
		h9.6V47H149.9z"
    />
  </svg>
);

export default RevHubLogo;
